import { formatCurrency } from '../../utils/formatCurrency';
import { globals } from 'common-ui';
import type { ProductCardProps } from './ProductCard';

const ProductCardPrice = (props: ProductCardProps) => {
  const { productPrice, productPriceOriginal, productNumberOfBottles, productMemberPrice } = props || {};

  const hasSalePrice = productPrice !== null && productPrice !== undefined;
  const hasRetailPrice =
    productPriceOriginal !== null && productPriceOriginal !== undefined && productPriceOriginal !== 0;
  const shouldShowOriginalPrice = hasSalePrice && hasRetailPrice && productPriceOriginal > productPrice;

  let displayPrice: number | null = null;
  if (hasSalePrice) {
    displayPrice = productPrice;
  } else if (hasRetailPrice) {
    displayPrice = productPriceOriginal;
  }

  return (
    <>
      <div className="product-price body1">
        {productNumberOfBottles && productNumberOfBottles !== 0 ? (
          <span className="product-card__bottles">
            {productNumberOfBottles} bottle{`${productNumberOfBottles > 1 ? 's :' : ' :'}`}
          </span>
        ) : (
          ''
        )}
        {displayPrice !== null && displayPrice !== undefined && (
          <>
            {shouldShowOriginalPrice ? (
              <span className="product-price__original strikeThrough">{formatCurrency(productPriceOriginal)}</span>
            ) : null}
            <span className="body1 bold">{formatCurrency(displayPrice)}</span>
          </>
        )}
      </div>

      {productMemberPrice && productMemberPrice !== 0 ? (
        <span className="product-card__member-price body1 bold">
          {formatCurrency(productMemberPrice)} {globals?.brandId === 'wsj' ? 'Advantage' : 'Unlimited'} Member Price
        </span>
      ) : (
        ''
      )}
    </>
  );
};

export default ProductCardPrice;
